import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import swal from 'sweetalert';

import {withStyles} from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import {swalCancelConfirm} from './utils';

class DeleteButton extends React.Component {

    static propTypes = {
        href: PropTypes.string.isRequired,
        confirmMessage: PropTypes.string,
        successMessage: PropTypes.string,
        errorMessage: PropTypes.string,
        handleSuccess: PropTypes.func,
    };

    static defaultProps = {
        confirmMessage: '',
        successMessage: '',
        errorMessage: '',
    };

    async onDeleteClicked() {
        const confirm = await swal({
            text: this.props.confirmMessage,
            dangerMode: true,
            ...swalCancelConfirm(),
        });

        if (confirm) {
            // Confirmed to delete item.
            await this.deleteItem();
        }
    }

    async deleteItem() {
        try {
            // Send request.
            let { data } = await axios.delete(this.props.href);

            // Show success message.
            await swal({
                text: this.props.successMessage,
                icon: "success",
            });

            // Refresh page to update data.
            this.props.handleSuccess ? this.props.handleSuccess() : location.reload()
        } catch (e) {
            // Show error in case of exception.
            swal({
                text: this.props.errorMessage,
                icon: "error",
            });
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <IconButton
                className={classes.dangerButton}
                onClick={this.onDeleteClicked.bind(this)}
            >
                <Icon>delete</Icon>
            </IconButton>
        );
    }
}

const styles = theme => ({
    dangerButton: {
        color: red[500],
    },
});

export default withStyles(styles)(DeleteButton);
